import React from 'react'
import * as S from './styles'
import { HowItWorksTexts } from '@shared/interfaces/HowItWorksTexts'
import HowItWorksList from '../HowItWorksList'
import HowItWorksHeader from '@site/components/molecules/HowItWorksHeader'
import { Page } from '@shared/interfaces/Pages'

const HowItWorks = ( { page, subscriptionPlans } : HowItWorks.Props ): React.ReactElement => {
  const textByPage = page !== 'home' ? HowItWorksTexts[ page ]( subscriptionPlans ) : HowItWorksTexts[ page ]

  return (
    <>
      <HowItWorksHeader
        title={ textByPage.title }
        subtitle={ textByPage.subtitle }
        color={ textByPage.colorText }
        page={ page }
      />
      <S.BodyBenefits className="how-it-works__body-benefits">
        <S.Wrapper className="how-it-works__wrapper">
          <HowItWorksList
            data={ textByPage.column }
            colorTitle={ textByPage.colorTextColumn }
          />
        </S.Wrapper>
      </S.BodyBenefits>
    </>
  )
}

namespace HowItWorks {
  export interface Props {
    page: Page
    subscriptionPlans?: any
  }
}

export default HowItWorks
